import moment from "moment-timezone";

export function DateToFiscalYear(date) {
  let month_th = Number(moment(date).format("MM"));
  let year_th = Number(moment(date).format("YYYY")) + 543;
  let fiscalYear = year_th + 1;

  if (month_th < 10) {
    fiscalYear = fiscalYear - 1;
  }
  return fiscalYear;
}

export function DateTimeToTime(date) {
  //date = date.substr(0, 10)
  date = date.replace('T', ' ').replace('Z', '');
  date = date.substr(11, 5)
  return date;
}

export function DateTHShort(date) {
  //date = date.substr(0, 10)
  // date = date.replace('T', ' ').replace('Z', '');
  let month_th = moment(date).format("MM");
  let year_th = Number(moment(date).format("YYYY")) + 543;
  let date_th = moment(date).format(`DD/${month_th}/${year_th}`);
  return date_th;
}
export function DateTHShortEN(date) {
  //date = date.substr(0, 10)
  date = date.replace('T', ' ').replace('Z', '');
  let month_th = moment(date).format("MM");
  let year_th = Number(moment(date).format("YYYY"));
  let date_th = moment(date).format(`DD/${month_th}/${year_th}`);
  return date_th;
}

export function DateTH(date) {
  let month_th = MonthTH(moment(date).format("MM"));
  let year_th = Number(moment(date).format("YYYY")) + 543;
  let date_th = moment(date).format(`DD ${month_th} ${year_th}`);
  return date_th;
}

export function DayToYear(num_day) {
  const days = num_day; // For example, 3 years
  const years = Math.floor(days / 365.25); // Round down to get the number of whole years
  const remainingDays = days % 365.25; // Get the number of days left over

  const months = Math.floor(remainingDays / 30.44); // Assuming an average of 30.44 days per month
  const daysLeft = Math.round(remainingDays % 30.44); // Round to the nearest whole number of days

  return { year: years, month: months, day: daysLeft };
}

export function MonthTH(num_month) {
  let month = [
    { value: "01", label: "มกราคม" },
    { value: "02", label: "กุมภาพันธ์" },
    { value: "03", label: "มีนาคม" },
    { value: "04", label: "เมษายน" },
    { value: "05", label: "พฤษภาคม" },
    { value: "06", label: "มิถุนายน" },
    { value: "07", label: "กรกฎาคม" },
    { value: "08", label: "สิงหาคม" },
    { value: "09", label: "กันยายน" },
    { value: "10", label: "ตุลาคม" },
    { value: "11", label: "พฤศจิกายน" },
    { value: "12", label: "ธันวาคม" },
  ];

  if (num_month) {
    num_month = Number(num_month);
    if (month[num_month - 1]) {
      return month[num_month - 1].label;
    } else {
      return "จำนวนเดือนไม่ถูกต้อง";
    }
  } else {
    return month;
  }
}

export function MonthTHToNumber(month_th) {
  const monthMap = {
    "มกราคม": "01",
    "กุมภาพันธ์": "02",
    "มีนาคม": "03",
    "เมษายน": "04",
    "พฤษภาคม": "05",
    "มิถุนายน": "06",
    "กรกฎาคม": "07",
    "สิงหาคม": "08",
    "กันยายน": "09",
    "ตุลาคม": "10",
    "พฤศจิกายน": "11",
    "ธันวาคม": "12"
  };

  if (month_th) {
    return monthMap[month_th] || "00";
  } else {
    return "00";
  }
}

export function MonthTH_Short(num_month) {
  let month = [
    { value: "01", label: "ม.ค." },
    { value: "02", label: "ก.พ." },
    { value: "03", label: "มี.ค." },
    { value: "04", label: "เม.ย." },
    { value: "05", label: "พ.ค." },
    { value: "06", label: "มิ.ย." },
    { value: "07", label: "ก.ค." },
    { value: "08", label: "ส.ค." },
    { value: "09", label: "ก.ย." },
    { value: "10", label: "ต.ค." },
    { value: "11", label: "พ.ย." },
    { value: "12", label: "ธ.ค." },
  ];

  if (num_month) {
    num_month = Number(num_month);
    if (month[num_month - 1]) {
      return month[num_month - 1].label;
    } else {
      return "จำนวนเดือนไม่ถูกต้อง";
    }
  } else {
    return month;
  }
}

export function dayTH(day_en) {
  let day_en_list = [
    { value: "Monday", label: "จันทร์" },
    { value: "Tuesday", label: "อังคาร" },
    { value: "Wednesday", label: "พุธ" },
    { value: "Thursday", label: "พฤหัสบดี" },
    { value: "Friday", label: "ศุกร์" },
    { value: "Saturday", label: "เสาร์" },
    { value: "Sunday", label: "อาทิตย์" },
  ];

  let day_short = day_en_list.filter((data) => data.value == day_en)[0].label;
  return day_short;
}

export function dayShort(day_en) {
  let day_en_list = [
    { value: "Monday", label: "จ." },
    { value: "Tuesday", label: "อ." },
    { value: "Wednesday", label: "พ." },
    { value: "Thursday", label: "พฤ." },
    { value: "Friday", label: "ศ." },
    { value: "Saturday", label: "ส." },
    { value: "Sunday", label: "อา." },
  ];

  let day_short = day_en_list.filter((data) => data.value == day_en)[0].label;
  return day_short;
}

export function DateMonthTH(date) {
  date = date.replace('T', ' ').replace('Z', '');
  let month_th = MonthTH_Short(moment(date).format("MM"));
  let date_th = moment(date).format(`DD ${month_th}`);
  return date_th;
}